import { useState } from 'react';
import { X } from 'lucide-react';
import { format } from 'date-fns';
import type { Notification } from '../hooks/use-notifications';

interface NotificationModalProps {
  notification: Notification;
  onClose: () => void;
}

const ANIMATION_DURATION = 300;

const NotificationModal = ({
  notification,
  onClose,
}: NotificationModalProps) => {
  const [isClosing, setIsClosing] = useState(false);

  const formattedDate = format(
    new Date(notification.createdAt),
    'd MMMM yyyy, HH:mm',
  );

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(onClose, ANIMATION_DURATION);
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-end justify-center bg-black/40"
      onClick={handleClose}
    >
      <div
        className={`w-full max-w-lg max-h-[70vh] flex flex-col bg-white rounded-t-2xl p-6 ${
          isClosing ? 'animate-slide-down' : 'animate-slide-up'
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-bold text-title">{notification.title}</h2>
          <button
            onClick={handleClose}
            className="text-subheading hover:text-title transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <p className="text-sm text-subheading mb-4">{formattedDate}</p>

        <div className="overflow-y-auto">
          <p className="text-sm text-title whitespace-pre-line leading-relaxed">
            {notification.text}
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotificationModal;
